import React, { FC, useEffect, useState } from 'react';
import {
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
} from '@mui/material';

import axios, { AxiosResponse } from 'axios';
import dayjs from 'dayjs';
import { twoDigitCurrencyFormatter } from 'utils/helpers/currencyFormatter';
import {
  TimeTableHeadCell,
  TimeTableCell,
  // StyledFilterWrapper,
  // TimeTableHeader,
} from 'molecules/TimeLogTable/TimeLogTable.styles';
import { neutrals } from 'utils/styles/color';
import loaderGif from 'assets/images/loaderGif.gif';
import { StyledTableCell } from 'molecules/Table/styles';
import { CloudOpsProjectsType } from 'pages/CompanyPage/types';

export interface IPaymentScheduleRow {
  id: number;
  project_id: string;
  invoice_period: string;
  amount: number;
  last_synced_at: string;
}

export interface IPaymentScheduleTableProps {
  project: CloudOpsProjectsType;
  currency: string;
}

const PaymentScheduleTable: FC<IPaymentScheduleTableProps> = ({
  project,
  currency,
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<IPaymentScheduleRow[]>([]);

  const { id_str } = project || {};

  useEffect(() => {
    fetchData();
  }, [id_str]);

  async function fetchData() {
    setLoading(true);
    const response: AxiosResponse<IPaymentScheduleRow[]> = await axios.get(
      `${process.env.REACT_APP_USER_SERVICE}/projects/payment-schedule/${id_str}`
    );

    setData(response.data || []);
    setLoading(false);
  }

  return (
    <>
      {/* <StyledFilterWrapper>
        <TimeTableHeader>
          {name}
        </TimeTableHeader>
      </StyledFilterWrapper> */}
      <TableContainer sx={{ maxHeight: 380 }}>
        {loading ? (
          <Box sx={{ textAlign: 'center' }}>
            <img src={loaderGif} alt="Data loading" />
          </Box>
        ) : (
          <Table stickyHeader aria-label="Time logs table">
            <TableHead>
              <TableRow>
                <TimeTableHeadCell>Period</TimeTableHeadCell>
                <TimeTableHeadCell>Amount</TimeTableHeadCell>
                <TimeTableHeadCell>Last Synced</TimeTableHeadCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {!data?.length ? (
                <>
                  <TableRow
                    sx={{
                      '.MuiTableCell-root': { borderBottom: 'none !important' },
                    }}
                  >
                    <StyledTableCell
                      colSpan={14}
                      sx={{
                        textAlign: 'center',
                        fontSize: '0.75rem !important',
                        fontWeight: '300 !important',
                        color: `${neutrals[500]} !important`,
                      }}
                    >
                      Payment schedule is not available.
                    </StyledTableCell>
                  </TableRow>
                  <TableRow
                    sx={{
                      '.MuiTableCell-root': { borderBottom: 'none !important' },
                    }}
                  >
                    <StyledTableCell colSpan={14} />
                  </TableRow>
                </>
              ) : (
                data.map((row, index) => (
                  <TableRow key={row.id || index}>
                    <TimeTableCell>
                      {dayjs(dayjs(row.invoice_period)).format('MMM D, YYYY')}
                    </TimeTableCell>
                    <TimeTableCell>
                      {twoDigitCurrencyFormatter(Number(row.amount), currency)}
                    </TimeTableCell>
                    <TimeTableCell>
                      {row.last_synced_at
                        ? dayjs(row.last_synced_at).format('MMM D, YYYY h:mm A')
                        : 'N/A'}
                    </TimeTableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        )}
      </TableContainer>
    </>
  );
};

export default PaymentScheduleTable;
